import React from 'react';
import { Form, Button } from 'react-bootstrap';
import { BiSearch, BiReset, BiExport } from 'react-icons/bi';
import { Tooltip } from '@mui/material';

const FilterComponent = ({ 
    formik, 
    onReset, 
    onSearch,
    children, 
    className = "", 
    showSearchButton = true,
    showResetButton = true ,
    createButton=null,
    extraAction = null ,
    createbuttonpaddingright = null,
    submitBtnLoading=false,
    disableResetButton=false,
    onExport = null,
    showExportButton = true,
    exportLoading = false,
    disableExportButton = false,
    disableExport = false,
}) => {
    return (
        <div className={`card-header border-0 ${className}`}>
            <div className="d-flex align-items-center react-date-picker position-relative my-1" style={{paddingRight:createbuttonpaddingright}}>
            <Form 
                onSubmit={(e) => {
                    e.preventDefault();
                    if (onSearch) {
                        onSearch(formik.values);
                    } else {
                        formik.handleSubmit(e);
                    }
                }} 
                onReset={onReset}
                className='react-date-picker'
            >
                    <div className="">
                        <div className="px-2 py-3 d-flex flex-row justify-content-start gap-2 align-items-center flex-wrap">
                            {/* Render custom filter fields passed as children */}
                            {children}
                            <div className="d-flex align-items-center gap-2 ">
                            {showSearchButton && (
                                <div>
                                    <Tooltip disableInteractive title="Search" placement='top' arrow>
                                        <Button className="btn btn-light btn-active-primary" 
                                        disabled={submitBtnLoading}
                                        type="submit">
                                            <span className="svg-icon svg-icon-3">
                                                <BiSearch />
                                            </span>

                                        </Button>
                                    </Tooltip>
                                </div>
                            )}
                            
                            {showResetButton && (
                                <div>
                                    <Tooltip disableInteractive title="Reset" placement='top' arrow>
                                        <Button className="btn btn-light btn-active-primary" 
                                        disabled={disableResetButton}
                                        type='reset'>
                                            <span className="svg-icon svg-icon-3">
                                                <BiReset />
                                            </span>
                                        </Button>
                                    </Tooltip>
                                </div>
                            )}
                            {showExportButton && (
                               <div>
                                    <Tooltip disableInteractive title={exportLoading ? 'Exporting...' : 'Export'} placement='top' arrow>
                                        <Button className="btn btn-light btn-active-primary"
                                            type="button"
                                            onClick={onExport}
                                            disabled={exportLoading || !onExport || disableExportButton || disableExport}
                                        >
                                            {exportLoading ? (
                                                <span
                                                    className="spinner-border spinner-border-sm"
                                                    role="status"
                                                    aria-hidden="true"
                                                />
                                            ) : (
                                                <span className="svg-icon svg-icon-3">
                                                    <BiExport />
                                                </span>
                                            )}
                                        </Button>
                                    </Tooltip>
                                </div>
                            )}
                             {extraAction && (
                                <div className="d-flex align-items-center">
                                    {extraAction}
                                </div>
                            )} {/* Right Side Create Button */}
                            </div>
                {createButton && (
                    <div className="ms-auto">
                        {createButton}
                    </div>
                )}
                        </div>
                    </div>
                </Form>
            </div>
            {/* {createButton&&createButton} */}
        </div>
    );
};

export default FilterComponent;

